// @flow
import keycode from 'keycode';

import ko from 'rgs-knockout';
const _ = require('lodash');
const $ = require('rgs-jquery');
import EventEmitter from 'events';

import { ContextBarContent, DEFAULT_CONTENT_PRIORITY } from './content.js';
const contextBarTemplate = require('../templates/context-bar.html');

export const cssClasses = {
	'container-rgs-context-bar': true,
	'container-fluid': true,
	'animated': true,
	'slideInUp': true,
};

type ContextBarRowOptions = {
	removeble: Boolean;
};

class ContextBarRow {
	constructor (content: ContextBarContent, options: ?ContextBarRowOptions) {
		this._options = options;
		this.allRegisteredContents = ko.observableArray();

		this.CurrentContent = ko.pureComputed(() => {
			let contents = this.allRegisteredContents()
				.filter(content => content.visible() && !content.empty());

			contents = _.reduce(contents, (max, x) => max.isAbove(x) ? max : x);

			return contents || null;
		});

		this.addContent(content);
	}

	addContent = (content: ContextBarContent): Object => {
		this.allRegisteredContents.push(content);

		const handle = {
			remove: () => {
				this.removeContent(content);
			},
		};

		handle.unregister = handle.remove;
		
		return handle;
	}

	removeContent = (content: ContextBarContent) => {
		this.allRegisteredContents.remove(content);
	}
}
export class ContextBar extends EventEmitter {
	constructor () {
		super(arguments);
		
		this._rows = ko.observableArray();

		this.Rows = ko.pureComputed(() => {
			const rows = this._rows();

			return rows
				.filter(row => row.CurrentContent())
				.sort((a, b) => a.CurrentContent().priority < b.CurrentContent().priority ? -1 : 1);
		});

		this._currentContentArray = ko.pureComputed(() => {
			const currentRows = this.Rows();

			return currentRows.map(row => row.CurrentContent());
		});

		/** 
		 * Дефолтный баннер определяется равенством приоритета его текущего контента константе DEFAULT_CONTENT_PRIORITY
		*/

		this._defaultRow = ko.pureComputed(() => {
			const rows = this._rows();

			return rows.find(
				row => row.CurrentContent()
					&& row.CurrentContent().priority === DEFAULT_CONTENT_PRIORITY
			);
		});

		this.template = {
			html: contextBarTemplate(),
			foreach: this._currentContentArray,
			afterAdd: this._afterAdd.bind(this),
			beforeRemove: this._beforeRemove.bind(this),
		};

		this.register = this.add;

		this.cssClasses = cssClasses;

		this._setEventListeners();
	}


	/*
	 * Добавляет дефолтный беннер, либо контент в него, если баннер уже существует
	*/
	add = (content: ContextBarContent): ContextBarRow => {
		let defaultRow = this._defaultRow();

		if (defaultRow) {
			defaultRow = defaultRow.addContent(content);
		} else {
			defaultRow = this.addRow(content);
		}

		return defaultRow;
	}

	_setEventListeners = () => {
		this.on('remove', this.remove);
	}

	remove = (content: ContextBarContent) => {
		const targetedRow = this._rows().find(
			row => row.allRegisteredContents()
				.some(registeredContent => registeredContent.ID === content.ID)
		);

		if (targetedRow) {
			const amountOfContent = targetedRow.allRegisteredContents().length;

			_.each(targetedRow.allRegisteredContents(), content => {
				content.dispose();
			});

			if (amountOfContent <= 1) {
				this._removeRow(targetedRow);
			} else {
				targetedRow.removeContent(content);
			}
		}
	}

	_removeRow = row => {
		this._rows.remove(row);
	}

	addRow = (content: ContextBarContent, options: ?ContextBarRowOptions) => {
		const removable = options && options.removable;

		if (removable) {
			content.removeSelf = () => {
				content.beforeRemove && content.beforeRemove();
				this.emit('remove', content);
			};

			content.removeSelfPressButtonHandler = (data, event) => {
				if (event.which === keycode('enter')) {
					content.removeSelf();
				}
			};
		}
		/** 
		 * В случае создания этим методом баннера с контентом, у которого priority === DEFAULT_CONTENT_PRIORITY,
		 * и когда дефолтный баннер уже был создан ранее,
		 * этот priority меняется на максимальный из имеющихся + 1
		*/
		if (content.priority === DEFAULT_CONTENT_PRIORITY && this._defaultRow()) {
			content.priority = Number(this._rows().reduce(
					(acc, cur) => {
						const accPriority = acc;
						const curPriority = cur.CurrentContent().priority;

						let result = accPriority;

						if (curPriority.isFinite()) {
							result = _.max([accPriority, curPriority]);
						}

						return result;
					}, DEFAULT_CONTENT_PRIORITY
				)) + 1;
		}


		
		const newRow = this._createRow(content);

		this._rows.push(newRow);
	}
	
	_afterAdd = (el) => {
		$(el).addClass('animated slideInUp');
	};

	_beforeRemove = (el) => {
		const rows = ko.dataFor($(el)[0])._rows();
		const shouldSwapCssClasses = rows.filter(
			row => row.CurrentContent()
		).length <= 1 || rows.length <= 1;

		if (shouldSwapCssClasses) {
			$(el).removeClass('slideInUp').addClass('slideOutDown');
			/** 
			 * TODO
			 * Анимация удаления бара не проигрывается по причине мгновенного удаления элемента.
			 * В случае отсрачивания через промис изменение последовательности выполнения скриптов ведёт
			 * к конфликтам с контекст-барами некоторых калькуляторов (vzr, rf, flat)
			 * Разобраться в причинах
			*/
			$(el).remove();
		} else {
			$(el).remove();
		}
	};

	_createRow = (content: ContextBarContent): ContextBarRow => new ContextBarRow(content);

}